<app-dialog
  #dialog
  [key]="'move-back-stage'"
  [action]="'move-back-stage'"
  [headerTheme]="'simple'"
  [title]="'Voltar o deal para ' + toLabel"
  [appendTo]="'body'"
  [maxWidth]="'520px'"
  (onClose)="onClose()">
  <!-- `appAutoFormGroup` obrigatório junto do `[formGroup]` (ver modal de valor). -->
  <div class="p-4" [formGroup]="form" appAutoFormGroup>
    <span class="move-back__label">Deal</span>
    <p class="move-back__deal">#{{ deal?.sequentialId }} · {{ deal?.corporateName }}</p>
    <p class="move-back__hint">
      O deal sai de <strong>{{ fromLabel }}</strong> e volta para <strong>{{ toLabel }}</strong
      >. O parceiro recebe um e-mail dizendo que o deal voltou, com o motivo abaixo.
    </p>

    <app-input
      [type]="'textarea'"
      [label]="'Motivo'"
      [placeholder]="'Ex.: faltou o balanço de 2025 assinado pelo contador.'"
      [required]="true"
      [textCenter]="false"
      formControlName="reason" />

    @if (form.get('reason')?.touched && form.get('reason')?.hasError('minlength')) {
      <p class="move-back__error">Escreva ao menos uma frase: o parceiro só tem este texto.</p>
    }
    @if (form.get('reason')?.hasError('maxlength')) {
      <p class="move-back__error">O motivo tem no máximo 2000 caracteres.</p>
    }
  </div>

  <ng-template #footer>
    <div class="dialog__footer move-back__footer">
      <!-- Cancelar devolve o card para a coluna de onde saiu (onClose → cancelled). -->
      <app-button
        [label]="'Cancelar'"
        [theme]="'outline-grey'"
        [type]="'button'"
        (sendButtonClick)="dialogRef?.close()"></app-button>
      <app-button
        [disabled]="!isFormValid()"
        [label]="'Voltar etapa'"
        [type]="'button'"
        (sendButtonClick)="submitAction()"></app-button>
    </div>
  </ng-template>
</app-dialog>
